export default {
  catalog: '/:id/catalogo',
  productDetail: '/:supplierId/catalogo/:productId',
};
